import { Row, Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { ButtonEditSummaryItem } from './editSummaryComponents/ButtonEditSummaryItem';
import { TitleSummary } from '../../style';

export const TextAreaComponent = ({ field, onEdit, widthSize }) => {
  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary>{field.label}</TitleSummary>
        <Row>
            <Input.TextArea
              className="textAreaSummary"
              value={field?.value}
              disabled
              autoSize
              style={{
                width: widthSize || '95%',
                maxHeight: widthSize ? '80px': 'none',
                resize: 'none',
                marginBottom: '10px',
                color: 'black',
                overflowY: 'scroll',
              }}
            />
          {onEdit != null ? <ButtonEditSummaryItem onClick={onEdit} /> : null}
        </Row>
      </React.Fragment>
    </>
  );
};

TextAreaComponent.propTypes = {
  field: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  widthSize: PropTypes.string,
};
